import { render } from "./uploads.vue?vue&type=template&id=693eb981"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"

import "./uploads.vue?vue&type=style&index=0&id=693eb981&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__